import React from 'react';
import { StyledTimeSlots } from "./TimeSlots.styles";

export const TimeSlots: React.FC = (props) => {
    return <StyledTimeSlots {...props}/>
};
